import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";
import { Seo } from "@/components/Seo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-900 px-6 py-20" data-testid="admin-login-page">
      <Seo title="Owner Login — Hussar Marine Concierge" description="Secure administrator login." />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-gold-400 text-sm mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>
        <div className="bg-navy-800 border border-gold-500/20 rounded-2xl p-8 sm:p-10 shadow-2xl">
          <div className="flex flex-col items-center text-center">
            <BrandMark className="h-16 w-16" />
            <h1 className="mt-5 font-serif text-2xl text-white">Owner & Admin Portal</h1>
            <p className="mt-2 text-sm text-slate-400">Secure access to leads and CRM</p>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <Label className="text-sm text-slate-300">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                className="mt-2 bg-navy-900 border-white/15 text-white placeholder:text-slate-500" data-testid="admin-email-input" />
            </div>
            <div>
              <Label className="text-sm text-slate-300">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
                className="mt-2 bg-navy-900 border-white/15 text-white placeholder:text-slate-500" data-testid="admin-password-input" />
            </div>
            {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-400 disabled:opacity-60 text-navy-900 font-semibold px-6 py-3.5 rounded-full transition-colors"
              data-testid="admin-login-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
